import React, { FocusEvent, useEffect, useState } from 'react';
import { Spinner } from '@fff-web/fff-ui-shared/Icon';
import { usePaymentContext } from '@fff-web/fff-payments';
import { trackElement } from '@fff-web/fff-analytics';
import styles from './scss/PromoGiftCard.module.scss';
import globalStyles from '../../../../global/globalStyles.module.scss';
import { useSharedContext } from '../../ContextProviders/SharedContext';

interface ErrorProps {
  message: string;
  code: string;
}

interface PromoGiftCardProps {
  promoCode: string,
  onBlur: (evt: FocusEvent<HTMLInputElement>) => void,
  error: ErrorProps | undefined,
}

const NOT_FOUND_CODE = 'INVALID_REDEMPTION_CODE';

const PromoGiftCard: React.FunctionComponent<PromoGiftCardProps> = (
  {
    promoCode,
    onBlur,
    error,
  },
) => {
  const { planCode, timerStatus } = useSharedContext();
  const { billingMethod } = usePaymentContext();
  const [isGiftCard, setGiftCard] = useState(false);
  const [promoCodeInteractionTracked, setPromoCodeInteractionTracked] = useState(false);
  useEffect(() => {
    if (promoCode.length === 16) {
      setGiftCard(true);
    } else {
      setGiftCard(false);
    }
  }, [promoCode]);

  const promoError = error?.code === NOT_FOUND_CODE;

  return (
    <>
      <div className={styles.orderInputGroup}>
        <input
          id="promoCode"
          type="text"
          defaultValue={promoCode}
          className={`${styles.orderInput} ${promoError ? globalStyles.INVALID_CLASS : null}`}
          placeholder="Promo Code/Gift Card"
          onBlur={(evt) => {
            if (!promoCodeInteractionTracked) {
              const properties = {
                customize_experience_type: 'preview_customize',
                plan_code: planCode,
                timer: timerStatus,
                payment_type: billingMethod.toLowerCase(),
                url: document.URL,
                path: document.location.pathname,
                option_title: 'coupon_code',
              };
              trackElement({
                elementName: 'Form Entry',
                properties,
              });
              setPromoCodeInteractionTracked(true);
            }
            onBlur(evt);
          }}
        />
        <div className={styles.orderInputBtn}><Spinner /></div>
      </div>
      {promoError
        && <p className={styles.orderPromoMessage}>This promotion code is not valid</p>}
      {!promoError && promoCode && !isGiftCard && (
      <p className={styles.orderPromoMessage}>
        {promoCode.toUpperCase()}
        {' '}
        has been applied.
      </p>
      )}
      {!promoError && isGiftCard && (
      <p className={styles.orderPromoMessage}>
        Your gift card has been applied! Any remaining credit will be added to your account.
      </p>
      )}
    </>
  );
};

export default PromoGiftCard;
